var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col md:flex-row" }, [
    _c("div", { staticClass: "md:w-80 mb-1 md:mb-0" }, [
      _c("h3", { staticClass: "font-medium text-sm md:text-base" }, [
        _vm._v(" " + _vm._s(_vm.label) + " "),
        _vm.optional
          ? _c("span", { staticClass: "font-normal text-gray-400" }, [
              _vm._v("(optional)"),
            ])
          : _vm._e(),
      ]),
    ]),
    _c(
      "div",
      [
        _vm._t("default", function () {
          return [
            _c("p", { staticClass: "text-gray-600" }, [
              _vm._v(_vm._s(_vm.value || _vm.defaultText)),
            ]),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }